import { createReducer, on } from '@ngrx/store';
import * as fromApp from './app.actions';
import { PushNotificationSchema } from '@capacitor/push-notifications';
import { AppDeepLink, AppStatus } from '@qvs/core';

export const appFeatureKey = 'app';

export interface State {
  keyboardIsOpen: boolean;
  keyboardOpenHeight: number;
  keyboardHeight: number;
  deepLink: AppDeepLink;
  pushNotification: PushNotificationSchema;
  pushNotificationActionId: string;
  tabsHidden: boolean;
  appStatus: AppStatus;
}

export const initialState: State = {
  keyboardIsOpen: false,
  keyboardOpenHeight: 0,
  keyboardHeight: 0,
  deepLink: {},
  pushNotification: null,
  pushNotificationActionId: null,
  tabsHidden: false,
  appStatus: AppStatus.INITIAL
};

export const reducer = createReducer(
  initialState,
  on(fromApp.keyboardWillOpen, (state, action) => ({
    ...state,
    keyboardOpenHeight: action.height,
    keyboardHeight: action.height || state.keyboardHeight
  })),
  on(fromApp.keyboardWillClose, (state) => ({
    ...state,
    keyboardOpenHeight: 0,
    keyboardIsOpen: true
  })),
  on(fromApp.keyboardIsOpen, (state) => ({
    ...state,
    keyboardIsOpen: true
  })),
  on(fromApp.keyboardIsClosed, (state) => ({
    ...state,
    keyboardIsOpen: false
  })),
  on(fromApp.pause, (state) => ({
    ...state,
    appStatus: AppStatus.PAUSED
  })),
  on(fromApp.resume, (state) => ({
    ...state,
    appStatus: AppStatus.RESUMED
  })),
  on(fromApp.appStartedByPushNotificationClick, (state, action) => ({
    ...state,
    pushNotification: action.pushNotification,
    pushNotificationActionId: action.actionId
  })),
  on(fromApp.resetAppStartedByDeepLinkClick, (state) => ({
    ...state,
    deepLink: {}
  })),
  on(fromApp.appStartedByDeepLinkClick, (state, action) => ({
    ...state,
    deepLink: action.deepLink
  })),
  on(fromApp.hideTabs, (state) => ({
    ...state,
    tabsHidden: true
  })),
  on(fromApp.unHideTabs, (state) => ({
    ...state,
    tabsHidden: false
  }))
);
